import { render, staticRenderFns } from "./DrivewealthCuratedRtq.vue?vue&type=template&id=608be0e7"
import script from "./DrivewealthCuratedRtq.vue?vue&type=script&lang=ts"
export * from "./DrivewealthCuratedRtq.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports